import Head from "next/head"

function Title({ title }: any) {
	const Title = `${title} | APIdrug Platform`
	return (
		<Head>
			<title>
				{Title} 
			</title>
		</Head>
	)
}

export default Title